import { PushParameter } from '../types';

type AdobeDataLayerHandler = {
  push: (params: PushParameter) => void;
};

let handler: AdobeDataLayerHandler | null = null;

export const AdobeDataLayerService = {
  /**
   * 핸들러 주입
   * @param h 핸들러
   */
  setHandler(h: AdobeDataLayerHandler) {
    handler = h;
  },

  push(params: PushParameter) {
    handler?.push(params);
  },

  pushDialogOpen(content: string, btnOKLabel: string, btnCancelLabel?: string) {
    const data = {
      dialog_data: {
        content,
        btnCancelLabel,
        btnOKLabel,
      },
    };

    handler?.push({ event: 'msg_dialog', data });
  },

  pushDialogClose(content: string, click_btn: string) {
    const data = {
      dialog_data: {
        content,
        click_btn,
      },
    };

    handler?.push({ event: 'msg_close', data });
  },
};
